export default __webpack_public_path__ + "static/media/shopify.914aaacb.svg";